"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapacitorSQLite = void 0;
const Database_1 = require("./electron-utils/Database");
const utilsJson_1 = require("./electron-utils/ImportExportJson/utilsJson");
const utilsFile_1 = require("./electron-utils/utilsFile");
class CapacitorSQLite {
    constructor() {
        this.versionUpgrades = {};
        this.databases = {};
        this.fileUtil = new utilsFile_1.UtilsFile();
        this.jsonUtil = new utilsJson_1.UtilsJson();
    }
    async createConnection(options) {
        const optionKeys = Object.keys(options);
        if (!optionKeys.includes('database')) {
            throw new Error('Must provide a database name');
        }
        const dbName = options.database;
        const version = options.version ? options.version : 1;
        /*    const encrypted = false;
        const inMode = "no-encryption";
    
        const encrypted: boolean =
          options.encrypted && this._osType === 'Darwin'
            ? options.encrypted
            : false;
        const inMode: string =
          options.mode && this._osType === 'Darwin'
            ? options.mode
            : 'no-encryption';
        */
        const readonly = options.readonly ? options.readonly : false;
        let upgrades = {};
        const versionUpgradeKeys = Object.keys(this.versionUpgrades);
        if (versionUpgradeKeys.length !== 0 &&
            versionUpgradeKeys.includes(dbName)) {
            upgrades = this.versionUpgrades[dbName];
        }
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const databaseConnection = new Database_1.Database(dbName + 'SQLite.db', 
        /*        encrypted,
        inMode,
        */
        version, readonly, upgrades);
        this.databases[connName] = databaseConnection;
        return;
    }
    async closeConnection(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            // close the database
            try {
                await database.close();
            }
            catch (err) {
                throw new Error(`CloseConnection command failed:  close ${dbName} failed ${err.message}`);
            }
        }
        // remove the connection from dictionary
        delete this.databases[connName];
    }
    async echo(options) {
        const echoValue = this.getOptionValue(options, 'value');
        const echoResult = {};
        echoResult.value = echoValue;
        return echoResult;
    }
    async open(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        try {
            await database.open();
            return;
        }
        catch (err) {
            throw new Error(`Open: ${err}`);
        }
    }
    async close(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            try {
                await database.close();
                return;
            }
            catch (err) {
                throw new Error(`Close: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`Close: ${msg}`);
        }
    }
    async getVersion(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            try {
                const version = await database.getVersion();
                const versionResult = {};
                versionResult.version = version;
                return versionResult;
            }
            catch (err) {
                throw new Error(`GetVersion: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`GetVersion: ${msg}`);
        }
    }
    async getTableList(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            try {
                const tableList = await database.getTableList();
                const tableListResult = {};
                tableListResult.values = tableList;
                return tableListResult;
            }
            catch (err) {
                throw new Error(`GetTableList: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`GetTableList: ${msg}`);
        }
    }
    async execute(options) {
        const dbName = this.getOptionValue(options, 'database');
        const statements = this.getOptionValue(options, 'statements');
        const transaction = this.getOptionValue(options, 'transaction', true);
        const readonly = options.readonly ? options.readonly : false;
        const connName = 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            if (readonly) {
                const msg = 'not allowed in read-only mode ';
                throw new Error(`Execute: ${msg}`);
            }
            try {
                const executeResult = await database.executeSQL(statements, transaction);
                if (executeResult < 0) {
                    throw new Error('Execute changes < 0');
                }
                else {
                    return { changes: { changes: executeResult } };
                }
            }
            catch (err) {
                throw new Error(`Execute: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`Execute: ${msg}`);
        }
    }
    async executeSet(options) {
        const dbName = this.getOptionValue(options, 'database');
        const setOfStatements = this.getOptionValue(options, 'set');
        const transaction = this.getOptionValue(options, 'transaction', true);
        const readonly = options.readonly ? options.readonly : false;
        const connName = 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        for (const sStmt of setOfStatements) {
            if (!('statement' in sStmt) || !('values' in sStmt)) {
                throw new Error('ExecuteSet: Must provide a set as ' + 'Array of {statement,values}');
            }
        }
        if (database.isDBOpen()) {
            if (readonly) {
                const msg = 'not allowed in read-only mode ';
                throw new Error(`ExecuteSet failed: ${msg}`);
            }
            try {
                const execSetResult = await database.execSet(setOfStatements, transaction);
                if (execSetResult < 0) {
                    throw new Error(`ExecuteSet failed changes <0`);
                }
                else {
                    return { changes: execSetResult };
                }
            }
            catch (err) {
                throw new Error(`ExecuteSet failed: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`ExecuteSet failed: ${msg}`);
        }
    }
    async run(options) {
        const dbName = this.getOptionValue(options, 'database');
        const statement = this.getOptionValue(options, 'statement');
        const values = this.getOptionValue(options, 'values', []);
        const transaction = this.getOptionValue(options, 'transaction', true);
        const readonly = options.readonly ? options.readonly : false;
        const connName = 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            if (readonly) {
                const msg = 'not allowed in read-only mode ';
                throw new Error(`Run failed: ${msg}`);
            }
            try {
                const runResult = await database.runSQL(statement, values, transaction);
                return { changes: runResult };
            }
            catch (err) {
                throw new Error(`RUN failed: ${err} `);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`Run failed: ${msg}`);
        }
    }
    async query(options) {
        const dbName = this.getOptionValue(options, 'database');
        const statement = this.getOptionValue(options, 'statement');
        const values = this.getOptionValue(options, 'values', []);
        if (statement.length === 0) {
            throw new Error('Query: Statement may not be an empty string.');
        }
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            try {
                const queryResult = await database.selectSQL(statement, values);
                return { values: queryResult };
            }
            catch (err) {
                throw new Error(`Query: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`Query: ${msg}`);
        }
    }
    async isDBExists(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        this.getDatabaseConnectionOrThrowError(connName);
        //    if (database.isDBOpen()) {
        const isExists = this.fileUtil.isFileExists(dbName + 'SQLite.db');
        return { result: isExists };
        //    } else {
        //      const msg = `Database ${dbName} not opened`;
        //     throw new Error(`isDBExists: ${msg}`);
        //    }
    }
    async isDBOpen(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        const isOpen = database.isDBOpen();
        return { result: isOpen };
    }
    async isDatabase(options) {
        const dbName = this.getOptionValue(options, 'database');
        const isExists = this.fileUtil.isFileExists(dbName + 'SQLite.db');
        return { result: isExists };
    }
    async isTableExists(options) {
        const dbName = this.getOptionValue(options, 'database');
        const tableName = this.getOptionValue(options, 'table');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            try {
                const isTableExistsResult = await database.isTableExists(tableName);
                return { result: isTableExistsResult };
            }
            catch (err) {
                throw new Error(`isTableExists: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`isTableExists: ${msg}`);
        }
    }
    async deleteDatabase(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (readonly) {
            const msg = 'not allowed in read-only mode ';
            throw new Error(`DeleteDatabase failed: ${msg}`);
        }
        try {
            await database.deleteDB(dbName + 'SQLite.db');
            return;
        }
        catch (err) {
            throw new Error(`DeleteDatabase: ${err}`);
        }
    }
    async isJsonValid(options) {
        const jsonString = this.getOptionValue(options, 'jsonstring');
        const jsonObj = JSON.parse(jsonString);
        const isValid = this.jsonUtil.isJsonSQLite(jsonObj);
        if (!isValid) {
            throw new Error('Stringify Json Object not Valid');
        }
        else {
            return { result: true };
        }
    }
    async importFromJson(options) {
        var _a, _b;
        const jsonString = this.getOptionValue(options, 'jsonstring');
        const jsonObj = JSON.parse(jsonString);
        const isValid = this.jsonUtil.isJsonSQLite(jsonObj);
        if (!isValid) {
            throw new Error('Must provide a valid JsonSQLite Object');
        }
        const vJsonObj = jsonObj;
        const dbName = `${vJsonObj.database}SQLite.db`;
        const targetDbVersion = (_a = vJsonObj.version) !== null && _a !== void 0 ? _a : 1;
        const mode = vJsonObj.mode;
        const overwrite = (_b = vJsonObj.overwrite) !== null && _b !== void 0 ? _b : false;
        //    const encrypted: boolean = vJsonObj.encrypted ?? false;
        //    const mode: string = encrypted ? 'secret' : 'no-encryption';
        // Create the database
        const database = new Database_1.Database(dbName, 
        /*encrypted, mode, */
        targetDbVersion, false, {});
        try {
            if (overwrite && mode === 'full') {
                const isExists = this.fileUtil.isFileExists(dbName);
                if (isExists) {
                    await this.fileUtil.deleteFileName(dbName);
                }
            }
            // Open the database
            await database.open();
            const tableList = await database.getTableList();
            if (mode === 'full' && tableList.length > 0) {
                const currentVersion = await database.getVersion();
                if (targetDbVersion < currentVersion) {
                    throw new Error(`ImportFromJson: Cannot import a version lower than ${currentVersion}`);
                }
                if (currentVersion === targetDbVersion) {
                    return { changes: { changes: 0 } };
                }
            }
            // Import the JsonSQLite Object
            const changes = await database.importJson(vJsonObj);
            // Close the database
            await database.close();
            return { changes: { changes: changes } };
        }
        catch (err) {
            throw new Error(`ImportFromJson: ${err}`);
        }
    }
    async exportToJson(options) {
        const dbName = this.getOptionValue(options, 'database');
        const exportMode = this.getOptionValue(options, 'jsonexportmode');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            try {
                const exportJsonResult = await database.exportJson(exportMode);
                const resultKeys = Object.keys(exportJsonResult);
                if (resultKeys.includes('message')) {
                    throw new Error(`exportToJson: ${exportJsonResult.message}`);
                }
                else {
                    return { export: exportJsonResult };
                }
            }
            catch (err) {
                throw new Error(`ExportToJson: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`ExportToJson: ${msg}`);
        }
    }
    async createSyncTable(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            if (readonly) {
                const msg = 'not allowed in read-only mode ';
                throw new Error(`CreateSyncTable failed: ${msg}`);
            }
            try {
                const createTableSyncResult = await database.createSyncTable();
                return {
                    changes: { changes: createTableSyncResult },
                };
            }
            catch (err) {
                throw new Error(`CreateSyncTable: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`CreateSyncTable: ${msg}`);
        }
    }
    async setSyncDate(options) {
        const dbName = this.getOptionValue(options, 'database');
        const syncDate = this.getOptionValue(options, 'syncdate');
        const readonly = options.readonly ? options.readonly : false;
        const connName = 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            if (readonly) {
                const msg = 'not allowed in read-only mode ';
                throw new Error(`SetSyncDate failed: ${msg}`);
            }
            try {
                await database.setSyncDate(syncDate);
                return;
            }
            catch (err) {
                throw new Error(`SetSyncDate: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`SetSyncDate: ${msg}`);
        }
    }
    async getSyncDate(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = readonly ? 'RO_' + dbName : 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            try {
                const ret = await database.getSyncDate();
                return Promise.resolve(ret);
            }
            catch (err) {
                throw new Error(`GetSyncDate: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`GetSyncDate: ${msg}`);
        }
    }
    async deleteExportedRows(options) {
        const dbName = this.getOptionValue(options, 'database');
        const readonly = options.readonly ? options.readonly : false;
        const connName = 'RW_' + dbName;
        const database = this.getDatabaseConnectionOrThrowError(connName);
        if (database.isDBOpen()) {
            if (readonly) {
                const msg = 'not allowed in read-only mode ';
                throw new Error(`DeleteExportedRows: ${msg}`);
            }
            try {
                await database.deleteExportedRows();
                return Promise.resolve();
            }
            catch (err) {
                throw new Error(`DeleteExportedRows: ${err}`);
            }
        }
        else {
            const msg = `Database ${dbName} not opened`;
            throw new Error(`DeleteExportedRows: ${msg}`);
        }
    }
    async addUpgradeStatement(options) {
        const dbName = this.getOptionValue(options, 'database');
        const upgrades = this.getOptionValue(options, 'upgrade');
        const firstUpgrade = upgrades[0];
        const versionUpgradeKeys = Object.keys(firstUpgrade);
        if (!versionUpgradeKeys.includes('toVersion') ||
            !versionUpgradeKeys.includes('statements')) {
            throw new Error('Must provide an upgrade capSQLiteVersionUpgrade Object');
        }
        if (typeof firstUpgrade.toVersion != 'number') {
            throw new Error('upgrade.toVersion must be a number');
        }
        if (this.versionUpgrades[dbName]) {
            this.versionUpgrades[dbName][firstUpgrade.toVersion] = firstUpgrade;
        }
        else {
            const upgradeVersionDict = {};
            upgradeVersionDict[firstUpgrade.toVersion] = firstUpgrade;
            this.versionUpgrades[dbName] = upgradeVersionDict;
        }
        return;
    }
    async copyFromAssets(options) {
        const overwrite = this.getOptionValue(options, 'overwrite', false);
        // check if the assets/database folder exists
        const assetsDbPath = this.fileUtil.getAssetsDatabasesPath();
        const pathExists = this.fileUtil.isPathExists(assetsDbPath);
        if (pathExists) {
            // get the database files
            const dbList = await this.fileUtil.getFileList(assetsDbPath);
            // loop through the database files
            dbList.forEach(async (db) => {
                if (this.fileUtil.getExtName(db) === '.db') {
                    // for each copy the file to the Application database folder
                    await this.fileUtil.copyFromAssetToDatabase(db, overwrite);
                }
                if (this.fileUtil.getExtName(db) === '.zip') {
                    const assetPath = this.fileUtil.getAssetsDatabasesPath();
                    await this.fileUtil.unzipDatabase(db, assetPath, overwrite);
                }
            });
            return;
        }
        else {
            throw new Error(`CopyFromAssets: assets/databases folder does not exist:[${assetsDbPath}]`);
        }
    }
    async getFromHTTPRequest(options) {
        const url = this.getOptionValue(options, 'url', '');
        const overwrite = this.getOptionValue(options, 'overwrite', false);
        if (url.length === 0) {
            throw new Error(`getFromHTTPRequest: You must give a database url`);
        }
        const cachePath = this.fileUtil.getCachePath();
        await this.fileUtil.downloadFileFromHTTP(url, cachePath);
        if (this.fileUtil.getExtName(url) === '.zip') {
            const zipName = `${this.fileUtil.getBaseName(url)}.zip`;
            await this.fileUtil.unzipDatabase(zipName, cachePath, overwrite);
        }
        if (overwrite) {
            await this.fileUtil.moveDatabaseFromCache();
        }
        else {
            throw new Error(`getFromHTTPRequest: cannot move file from cache overwrite: ${overwrite}`);
        }
    }
    async getDatabaseList() {
        // get the database folder
        const pathDatabase = this.fileUtil.getDatabasesPath();
        // get the list of databases
        const files = await this.fileUtil.getFileList(pathDatabase);
        if (files.length > 0) {
            return { values: files };
        }
        else {
            throw new Error(`isTableExists: No databases found in [${pathDatabase}]`);
        }
    }
    async checkConnectionsConsistency(options) {
        const dbNames = this.getOptionValue(options, 'dbNames');
        const openModes = this.getOptionValue(options, 'openModes');
        const checkConsistencyResult = {};
        checkConsistencyResult.result = false;
        const dbConns = [];
        dbNames.forEach((value, i) => {
            dbConns.push(`${openModes[i]}_${value}`);
        });
        try {
            let inConnectionsSet = new Set(Object.keys(this.databases));
            const outConnectionSet = new Set(dbConns);
            if (outConnectionSet.size === 0) {
                await this.resetDbDict(Object.keys(this.databases));
                return Promise.resolve(checkConsistencyResult);
            }
            if (inConnectionsSet.size < outConnectionSet.size) {
                await this.resetDbDict(Object.keys(this.databases));
                return Promise.resolve(checkConsistencyResult);
            }
            if (inConnectionsSet.size > outConnectionSet.size) {
                for (const key of inConnectionsSet) {
                    if (!Array.from(outConnectionSet.keys()).includes(key)) {
                        const opt = {};
                        let readonly = false;
                        if (key.substring(0, 3) === 'RO_') {
                            readonly = true;
                        }
                        opt.database = key.substring(3);
                        opt.readonly = readonly;
                        await this.closeConnection(opt);
                    }
                }
            }
            inConnectionsSet = new Set(Object.keys(this.databases));
            if (inConnectionsSet.size === outConnectionSet.size) {
                const symmetricDifferenceSet = await this.symmetricDifference(inConnectionsSet, outConnectionSet);
                if (symmetricDifferenceSet.size === 0) {
                    checkConsistencyResult.result = true;
                    return checkConsistencyResult;
                }
                else {
                    await this.resetDbDict(Object.keys(this.databases));
                    return checkConsistencyResult;
                }
            }
            else {
                await this.resetDbDict(Object.keys(this.databases));
                return checkConsistencyResult;
            }
        }
        catch (err) {
            throw new Error(`CheckConnectionsConsistency: ${err}`);
        }
    }
    async resetDbDict(keys) {
        try {
            for (const key of keys) {
                const opt = {};
                let readonly = false;
                if (key.substring(0, 3) === 'RO_') {
                    readonly = true;
                }
                opt.database = key.substring(3);
                opt.readonly = readonly;
                await this.closeConnection(opt);
            }
        }
        catch (err) {
            throw new Error(`ResetDbDict: ${err}`);
        }
    }
    async symmetricDifference(setA, setB) {
        const difference = new Set(setA);
        for (const elem of setB) {
            if (difference.has(elem)) {
                difference.delete(elem);
            }
            else {
                difference.add(elem);
            }
        }
        return difference;
    }
    /**
     * Returns a database connection, if it already exists.
     * If the conneciton does not exist yet, it throws an error.
     *
     * @param dbName
     * @returns
     */
    getDatabaseConnectionOrThrowError(dbName) {
        const databaseNames = Object.keys(this.databases);
        if (!databaseNames.includes(dbName)) {
            throw new Error(`No connection available for database "${dbName}"`);
        }
        return this.databases[dbName];
    }
    /**
     * Gets the value of an option from the options object.
     * If the `optionKey` does not exist and there is no `defaultValue` defined, an exception is thrown.
     * If the `optionKey` does not exist but there is a `defaultValue`, the `defaultValue` is returned.
     *
     * @param options
     * @param optionKey
     * @param defaultValue
     * @returns
     */
    getOptionValue(options, optionKey, defaultValue = undefined) {
        const optionKeys = Object.keys(options);
        if (!optionKeys.includes(optionKey)) {
            if (defaultValue === undefined) {
                throw new Error(`Must provide "${optionKey}" in options.`);
            }
            else {
                return defaultValue;
            }
        }
        return options[optionKey];
    }
    ////////////////////////////////
    //// UNIMPLEMENTED METHODS
    ////////////////////////////////
    async getMigratableDbList(options) {
        console.log('getCordovaDbList', options);
        throw new Error('Method not implemented.');
    }
    async addSQLiteSuffix(options) {
        console.log(`${JSON.stringify(options)}`);
        throw new Error('Method not implemented.');
    }
    async deleteOldDatabases(options) {
        console.log(`${JSON.stringify(options)}`);
        throw new Error('Method not implemented.');
    }
    async moveDatabasesAndAddSuffix(options) {
        console.log(`${JSON.stringify(options)}`);
        throw new Error('Method not implemented.');
    }
    async getUrl() {
        throw new Error('Method not implemented.');
    }
    async initWebStore() {
        throw new Error('Method not implemented.');
    }
    async saveToStore(options) {
        console.log(`${JSON.stringify(options)}`);
        throw new Error('Method not implemented.');
    }
    async isSecretStored() {
        throw new Error('Method not implemented.');
    }
    async setEncryptionSecret(options) {
        console.log(`${JSON.stringify(options)}`);
        throw new Error('Method not implemented.');
    }
    async changeEncryptionSecret(options) {
        console.log(`${JSON.stringify(options)}`);
        throw new Error('Method not implemented.');
    }
    async clearEncryptionSecret() {
        console.log('clearEncryptionSecret');
        throw new Error('Method not implemented.');
    }
    async getNCDatabasePath(options) {
        console.log('getNCDatabasePath', options);
        throw new Error('Method not implemented.');
    }
    async createNCConnection(options) {
        console.log('createNCConnection', options);
        throw new Error('Method not implemented.');
    }
    async closeNCConnection(options) {
        console.log('closeNCConnection', options);
        throw new Error('Method not implemented.');
    }
    async isNCDatabase(options) {
        console.log('isNCDatabase', options);
        throw new Error('Method not implemented.');
    }
}
exports.CapacitorSQLite = CapacitorSQLite;
//# sourceMappingURL=index.js.map